<!-- routify:options param-is-page=true -->
<script lang="ts">
  import DistributorsStore from "@shared/svelte/Stores/DistributorsStore";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import Spinner from "@shared/svelte/Components/SpinnerInternal.svelte";
  import { params, redirect } from "@roxi/routify";
  import userContext from "@modern/services/user_context";
  import cart from "@modern/services/cart";
  import SponsoredContentPage from "@modern/components/retailer/SponsoredContentPage/SponsoredContentPage.svelte";

  const sponsoredContentPageRes = async () => {
    try {
      let res = await HttpPromise({
        method: "GET",
        url: "/api/retailer/sponsored_content_pages/show_by_slug",
        data: { slug: $params.slug },
      });
      return res;
    } catch (e) {
      $redirect("/404", {}, { static: false });
    }
  };

  const distributorsRes = async () => {
    // TODO: CachedRequest?
    let res = await HttpPromise({
      method: "GET",
      url: "/api/retailer/distributors",
      data: {
        with_cutoff_time: true,
        with_integrated: true,
        with_sales_reps: true,
        with_domains: true,
      },
    });
    DistributorsStore.set(res);
  };

  const load = async () => {
    const promises1 = [sponsoredContentPageRes(), distributorsRes()];

    let results1 = await Promise.all(promises1);

    return {
      sponsoredContentPageRes: results1[0],
    };
  };

  const Cart = cart.getCartService();

</script>

{#await load()}
  <Spinner />
{:then data}
  <SponsoredContentPage sponsoredContentPage={data.sponsoredContentPageRes} {Cart} />
{/await}
